import React from "react";
//#region types
import { RepeatCellsProps } from "models/propTypes/simpleTableProps";
//#endregion
//#region components
import { TableCell } from "@mui/material";
import useValueFormatter from "../../useValueFormatter";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";

const RepeatCells: React.FC<RepeatCellsProps> = ({
  index,
  depth,
  row,
  sumValueRow,
  repeatPropertyKey,
  repeatPropertiesList,
  repeatPropertiesLength,
  repeatColumnLength,
  sumNegative,
  showTotal,
}) => {
  const { getFormattedValue } = useValueFormatter();

  const getColumnSumNegative = (repeatColumnIndex: number) => {
    const checkValueRow = sumValueRow ?? row;
    const repeatValue = repeatPropertyKey ? checkValueRow[repeatPropertyKey] : undefined;
    return (
      sumNegative && checkValueRow && repeatValue && sumNegative(checkValueRow[repeatPropertyKey][repeatColumnIndex])
    );
  };

  return (
    <>
      {[...Array(repeatColumnLength)].map((col, repeatIndex) => (
        <React.Fragment key={`repeat-columns-${repeatIndex}`}>
          {repeatPropertiesList.map(([repeatKey, cellValue], cellIndex) => (
            <TableCell
              key={`tab-repeatCell-${repeatIndex}${cellIndex}`}
              className={clsx(
                cssExports.tableCell,
                cellIndex === repeatPropertiesLength - 1 && (showTotal || repeatIndex !== repeatColumnLength - 1)
                  ? cssExports.repeatEnd
                  : "",
                cellIndex === 0 ? cssExports.repeatTitleCell : cssExports.repeatCell,
                cellValue?.isTextSmall ? cssExports.textSmall : "",
                cellValue?.className,
                cssExports.truncateString,
                getColumnSumNegative(repeatIndex) ? cssExports.sumNegative : ""
              )}
              align={cellValue?.alignment}
              style={{
                width: cellValue?.width,
                maxWidth: cellValue?.maxWidth,
              }}
            >
              {row[repeatPropertyKey] !== undefined
                ? getFormattedValue(
                    cellValue?.formatter
                      ? cellValue.formatter(row[repeatPropertyKey][repeatIndex], index, depth, repeatIndex, row)
                      : row[repeatPropertyKey][repeatIndex][repeatKey]
                  )
                : ""}
            </TableCell>
          ))}
        </React.Fragment>
      ))}
    </>
  );
};

export default RepeatCells;
